import './Tosaccept.css';

import { Component } from 'react';
import { Flow } from 'flow-react';
import { Container, Row, Col} from 'react-bootstrap';

class Tosaccept extends Component {

	
	
  _agreecb = (evt) => {
		evt.preventDefault();
		this.props.flow.ftvfeAcceptTos()
	}
	
  agreecb = (evt) => {
		evt.preventDefault();
    this.props.flow.ftvfeAcceptTos()
      .then(res=>{
          this.props.accepttoscb();
      }).catch(e => {
					console.log(e);
      });
  }



  render() {
    return (
			<Container className="actos" fluid>
				<Row>
				<Col md={1} /> 
					<Col md={11}> 
						<form className="form" onSubmit={this.agreecb}>
							J'ai lu et j'accepte les conditions <a target="_blank" href="https://francetv.flowcenter.de/gdpr">générales d'utilisation</a>
							<div className="formrow logbutrow">
								<input className="loginsubmit" type="submit" value="Accepter" />
							</div>
						</form>
					</Col>
				</Row>
      </Container>
   );
  }
}

export default Flow.injectFlow(Tosaccept);